import { render, staticRenderFns } from "./NewDetail.vue?vue&type=template&id=0f44f57c&scoped=true&"
import script from "./NewDetail.vue?vue&type=script&lang=js&"
export * from "./NewDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewDetail.vue?vue&type=style&index=0&id=0f44f57c&prod&scoped=true&lang=css&"
import style1 from "./NewDetail.vue?vue&type=style&index=1&id=0f44f57c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f44f57c",
  null
  
)

export default component.exports